// Module
var code = "<div class=\"flex layout-column\">\r\n    <mn-system-parameter class=\"flex\" key=\"oximetry_config\" attr=\"exam_motifs\">\r\n        <mn-oximetry-config-table mn-model=\"vm.model\" mn-auto-save=\"vm.handleAutoSave\" attr=\"exam_motifs\">\r\n        </mn-oximetry-config-table>\r\n    </mn-system-parameter>\r\n</div>";
// Exports
module.exports = code;